import { BASE_CRM_EDGES } from './base-crm';
import { SALES_EDGES } from './sales';
import { MARKETING_EDGES } from './marketing';
import { PEVC_DEALFLOW_EDGES } from './pevc-dealflow';
import { PEVC_PORTFOLIO_EDGES } from './pevc-portfolio';
import { PEVC_FUNDRAISING_EDGES } from './pevc-fundraising';
import { PEVC_IR_EDGES } from './pevc-ir';
import { PMN_EDGES } from './pmn';

export * from './base-crm';
export * from './sales';
export * from './marketing';
export * from './pevc-dealflow';
export * from './pevc-portfolio';
export * from './pevc-fundraising';
export * from './pevc-ir';
export * from './pmn';

/**
 * Central registry mapping edge type to definition (schema + UI config + constraints)
 */
export const EDGE_REGISTRY = {
  ...BASE_CRM_EDGES,
  ...SALES_EDGES,
  ...MARKETING_EDGES,
  ...PEVC_DEALFLOW_EDGES,
  ...PEVC_PORTFOLIO_EDGES,
  ...PEVC_FUNDRAISING_EDGES,
  ...PEVC_IR_EDGES,
  ...PMN_EDGES,
};

/**
 * Get edge definition for a type
 */
export function getEdgeDefinition(edgeType: string) {
  return EDGE_REGISTRY[edgeType];
}

/**
 * Get schema for an edge type
 */
export function getEdgeSchema(edgeType: string) {
  return EDGE_REGISTRY[edgeType]?.schema;
}

/**
 * Check if edge type is valid
 */
export function isValidEdgeType(edgeType: string): boolean {
  return edgeType in EDGE_REGISTRY;
}

/**
 * Get all valid edge types
 */
export function getAllEdgeTypes(): string[] {
  return Object.keys(EDGE_REGISTRY);
}

/**
 * Check if an edge type allows a given source node type
 */
export function isValidSourceType(edgeType: string, nodeType: string): boolean {
  const edgeDef = EDGE_REGISTRY[edgeType];
  if (!edgeDef) return true;
  return edgeDef.sourceTypes.includes('*') || edgeDef.sourceTypes.includes(nodeType);
}

/**
 * Check if an edge type allows a given target node type
 */
export function isValidTargetType(edgeType: string, nodeType: string): boolean {
  const edgeDef = EDGE_REGISTRY[edgeType];
  if (!edgeDef) return true;
  return edgeDef.targetTypes.includes('*') || edgeDef.targetTypes.includes(nodeType);
}
